/**
 * The exam verdict (`U` / `G` / `VG`) as a `Badge` tone.
 *
 * Shared because four pages showed the same badge with their own copy of this
 * mapping: the exam result, the progress exam history and the teacher's
 * student-detail and exam pages.
 */
import type { BadgeTone } from "@client/components/ui";

export type Verdict = "U" | "G" | "VG";

export function verdictTone(verdict: Verdict | null | undefined): BadgeTone {
  if (verdict === "VG") return "success";
  if (verdict === "G") return "accent";
  if (verdict === "U") return "danger";
  return "neutral";
}
